import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DfModuleImageModule } from '@df/module-image/df-module-image.module';
import { OptionLabelPipe } from '@df/ui/common/option-label.pipe';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { AnalysisCalculatorComponent } from './../../../../cms/analysis-calculator/analysis-calculator.component';
import { FormMuiFieldComponent } from './../../../../common/form/mui-field/form-mui-field.component';
import { TextBoxComponent } from './../../../../common/text-box/text-box.component';

@Component({
    standalone: true,
    imports: [TextBoxComponent, DfModuleImageModule, TranslationModule, FormMuiFieldComponent, FormsModule, OptionLabelPipe],
    selector: 'product-view-calculator',
    templateUrl: './product-view-calculator.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductViewCalculatorComponent extends AnalysisCalculatorComponent {}
